export type ReactAppStage = "dev" | "test" | "demo" | "local";

let fallbackReported = false;

/**
 * An unrecognised stage falls back to "demo", which points the app at the production gateway
 * (`api.l`). CI once built every bundle without `VITE_APP_STAGE`, so dev and test web previews
 * silently talked to production for the entire life of the build. The fallback stays — throwing
 * here would white-screen the app, and this runs on render paths — but it no longer passes
 * unnoticed.
 */
const fallbackToDemo = (reason: string): ReactAppStage => {
  if (!fallbackReported) {
    fallbackReported = true;
    console.error(`reactAppStage: ${reason}, falling back to "demo" — this build talks to the production gateway.`);
  }
  return "demo";
};

/**
 * Returns react app stage version.
 */
export const reactAppStage = (): ReactAppStage => {
  const appStage = localStorage.getItem("REACT_APP_STAGE") ?? import.meta.env.VITE_APP_STAGE;
  switch (appStage) {
    case "dev":
      return "dev";
    case "test":
      return "test";
    case "demo":
    case "prod":
      return "demo";
    case "local":
      return "local";
    case undefined:
    case null:
    case "":
      return fallbackToDemo("VITE_APP_STAGE was not set at build time");
    default:
      return fallbackToDemo(`unknown stage "${appStage}"`);
  }
};
